import { makeStyles } from "tss-react/mui";

export const useStles = makeStyles()((theme) => ({
  root: {
    height: "clamp(100%, 100%, calc(100vh - 64px))",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    height: 96,
    display: "flex",
    justifyContent: "flex-start",
    backgroundColor: "var(--bg-secondary)",
    alignItems: "center",
    gap: 4,
    padding: "22px 0 22px 80px",
  },
  spinner: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    margin: "auto",
  },
  btnCompare: {
    height: 40,
    width: "160px !important",
    marginTop: 232,
    "&.Mui-disabled": {
      backgroundColor: "var(--bg-border-gray) !important",
      color: "var(--color-secondary) !important",
    },
  },
  btnBack: {
    fontSize: "1rem",
    marginLeft: -12,
  },
  backIcon: {
    marginRight: 4,
  },
  headerTitle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },
  title: {
    fontSize: theme.typography.pxToRem(22),
    lineHeight: "normal",
    color: "var(--color-primary)",
    fontWeight: 600,
  },
  content: {
    paddingLeft: 80,
    paddingBottom: 80,
    display: "flex",
    backgroundColor: "var(--bg-secondary)",
    height: "100%",
    flexDirection: "column",
    justifyContent: "start",
    gap: 30,
    "@media(max-width: 1570px)": {
      paddingLeft: 60,
      paddingBottom: 60,
    },
  },
  cardsWrapper: {
    display: "flex",
    justifyContent: "start",
    gap: 71,
    "@media(max-width: 1570px)": {
      gap: 60,
    },
  },
  card: {
    width: 595,
    height: 520,
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "center",
    borderStartEndRadius: 8,
    borderStartStartRadius: 8,
    backgroundColor: "var(--bg-card-secondary)",
    "@media(max-width: 1570px)": {
      width: 504,
      height: 456,
    },
  },
  cardTitleWrapper: {
    height: 220,
    fontSize: 20,
    fontWeight: 600,
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  cardTitle: {
    marginTop: 53,
    color: "var(--color-primary)",
    fontWeight: 600,
  },
  cardTitleFirst: {
    backgroundColor: "var(--bg-blue)",
  },
  cardTitleSecond: {
    backgroundColor: "var(--bg-purple)",
  },
  versionWrapper: {
    position: "relative",
    height: 267,
    width: 472,
    margin: 62,
    marginTop: -100,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    "@media(max-width: 1570px)": {
      width: 392,
      height: 263,
      margin: 56,
      marginTop: -80,
    },
  },
  btnChangeVersion: {
    "@media(max-width: 1570px)": {
      marginBottom: 20,
    },
  },
  referenceVersion: {
    backgroundColor: "var(--color-secondary)",
  },
  selectVersionWrapper: {
    backgroundColor: "var(--bg-secondary)",
    border: "4px dashed var(--bg-border-gray)",
    borderStyle: "dashed",
  },
  btnAdd: {
    cursor: "pointer",
  },
  plusIcon: {
    fontSize: 64,
    color: "var(--bg-gray)",
  },
  addTitle: {
    fontSize: theme.typography.pxToRem(20),
    color: "var(--color-primary)",
  },
  projectTitle: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 600,
    textAlign: "center",
    color: "var(--color-primary)",
  },
  versionTitle: {
    fontSize: theme.typography.pxToRem(20),
    textAlign: "center",
    fontWeight: 600,
    color: "var(--color-primary)",
    "& span": {
      fontWeight: 300,
    },
  },
  validationWrapper: {
    paddingTop: 43,
    maxHeight: "fit-content",
    backgroundColor: "var(--bg-secondary)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "end",
    "@media(max-width: 1570px)": {
      paddingTop: 20,
    },
  },
}));
